import type { BrandingConfig } from '../model/types';

export function applyBrandingToDocument(branding: BrandingConfig): void {
  document.title = branding.title;
  document.documentElement.dataset.appTheme = branding.themeId;
  const description = document.querySelector<HTMLMetaElement>(
    'meta[name="description"]',
  );
  if (description) description.content = branding.description;
  const favicon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (favicon) favicon.href = branding.faviconHref;
}
